import { render, staticRenderFns } from "./buildingTodo.vue?vue&type=template&id=4123699c&"
import script from "./buildingTodo.vue?vue&type=script&lang=js&"
export * from "./buildingTodo.vue?vue&type=script&lang=js&"
import style0 from "./buildingTodo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports